import React, { Component } from "react";
import PropTypes from "prop-types";
import $ from "jquery";
const uniqueString = require("unique-string");

export default class SVGnumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      elementId: uniqueString()
    };
    this.doResize = null;
  }

  scrollFunction = async () => {
    clearTimeout(this.doResize);
    try {
      if (
        this.state.elementId &&
        $(`.number-${this.state.elementId}`) &&
        $(`.number-${this.state.elementId}`).is(":visible")
      ) {
        const elementFromTop = $(`.number-${this.state.elementId}`).offset()
          .top;
        const elementHeight = $(`.number-${this.state.elementId}`).height();
        const windowHeight = $(window).height();
        const margin = 200;
        this.doResize = setTimeout(() => {
          const fromTop = $(window).scrollTop();
          if (
            fromTop + windowHeight > elementFromTop - margin &&
            fromTop < elementFromTop + elementHeight + margin
          ) {
            const value =
              ((fromTop - (elementFromTop - windowHeight)) * 100) /
              (elementFromTop +
                elementHeight -
                (elementFromTop - windowHeight));
            $(
              `.number-${this.state.elementId} #fillshape-${
                this.state.elementId
              }`
            ).css({ height: value + "%", width: "100%" });
          }
        }, 100);
      } else {
        $(window).off("scroll", this.scrollFunction);
      }
    } catch (err) {
      console.error(err);
    }
  };

  componentDidMount() {
    if (this.props.animate) {
      $(window).scroll(this.scrollFunction);
    }
  }

  componentWillUnmount() {
    $(window).off("scroll", this.scrollFunction);
  }

  render() {
    const { version } = this.props;
    return (
      <svg
        className={`animate-number number-${this.state.elementId} ${
          this.props.classes
        }`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 425.19 217.91"
      >
        <defs>
          <clipPath
            id={`clip-path-${this.state.elementId}`}
            transform="translate(0 0)"
          >
            <rect
              id={`fillshape-${this.state.elementId}`}
              style={{ height: 0 + "%", transition: "all .2s linear" }}
            />
          </clipPath>
        </defs>
        <g>
          <path
            d="M202.35,51c-13.59-25.59-50-43.91-92.78-43.91C55.19,7.1,11.1,36.7,11.1,73.21V148.9c0,36.51,44.09,66.11,98.47,66.11,42.78,0,79.19-18.32,92.78-43.91A47,47,0,0,0,208,148.9V73.21A47,47,0,0,0,202.35,51ZM57,157.8A1.86,1.86,0,0,1,55.6,156L55.5,73.21c0-20,24.21-36.3,54.07-36.3,17.75,0,33.51,5.74,43.37,14.62h0L70.21,134a38.67,38.67,0,0,0-11,22.33h0A1.8,1.8,0,0,1,57,157.8Zm106.68-8.91c0,8.36-4.21,16.06-11.29,22.2-9.89,8.58-25.38,14.1-42.78,14.1-18.45,0-34.73-6.21-44.49-15.68l82-81.8A45.26,45.26,0,0,0,160,61.6h0a1.86,1.86,0,0,1,1.34-1.6,1.8,1.8,0,0,1,2.25,1.74Z"
            transform="translate(0 0)"
            style={{
              fill: this.props.colorBorder,
              stroke: this.props.colorBorder,
              strokeMiterlimit: "10"
            }}
          />
          {version === 1 && (
            <path
              d="M352.94,198.91H334c-2.88,0-4-3.33-2.12-5.48l17-23.47a21.2,21.2,0,0,0,4-12.44V14.67H318.25l-74.79,75.1v30.15l0.15,0.15,89.49-89.4A1.8,1.8,0,0,1,335.8,33h0a123,123,0,0,0-25.38,74.82v91.07H231v8.51H416.72v-8.51H352.94Z"
              transform="translate(0 0)"
              style={{
                fill: this.props.colorBorder,
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10"
              }}
            />
          )}
          {version === 2 && (
            <path
              d="M411.73,189.17a3.15,3.15,0,0,1-5.48,2.12l-23.47-17a21.21,21.21,0,0,0-12.44-4H349.9a197.72,197.72,0,0,0-49.82,6.38l-46,12a1.8,1.8,0,0,1-1.13-3.4l119.77-49c27.93-11.18,49.61-26.38,49.61-57.92,0-36.51-44.09-66.11-98.47-66.11-42.78,0-79.19,18.32-92.78,43.91a47,47,0,0,0-5.69,22.2h44.4c0-8.36,4.21-16.06,11.29-22.2C291,47.48,306.45,42,323.85,42c29.86,0,54.07,16.25,54.07,36.3,0,14.21-7.09,24-31.09,36-12,6-114.75,55.92-114.75,55.92v0h-0.27v39.69H421.33V170.26h-9.6v18.91Z"
              transform="translate(0 0)"
              style={{
                fill: this.props.colorBorder,
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10"
              }}
            />
          )}
          {version === 3 && (
            <path
              d="M426.29,142.29a47,47,0,0,0-5.69-22.2,58.75,58.75,0,0,0-6.89-10.15C397.3,90.34,370.66,82.57,346,89.26l-17.16,4.65a1.8,1.8,0,0,1-1.16-3.39L419.11,52.2V12.53H229.59V52.21h9.58v-19a3.15,3.15,0,0,1,5.48-2.12L263.9,45.07a37.56,37.56,0,0,0,22,7.14h77.27L258.27,96v10h69.55c17.4,0,32.89,5.52,42.78,14.1,6.8,5.89,10.94,13.23,11.26,21.2h0c0,0.72.06,1.44,0.06,2.18,0,20.05-24.21,36.3-54.07,36.3-17.4,0-32.89-5.52-42.78-14.1-7.08-6.14-11.29-13.84-11.29-22.2h-44.4a47,47,0,0,0,5.69,22.2c13.59,25.59,50,43.91,92.78,43.91,54.38,0,98.47-29.6,98.47-66.11,0-.4,0-0.79,0-1.18h0Z"
              transform="translate(0 0)"
              style={{
                fill: this.props.colorBorder,
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10"
              }}
            />
          )}
          {version === 4 && (
            <path
              d="M372.23,15.59V132h-74a93.12,93.12,0,0,0-56.59,19.17h0a1.8,1.8,0,0,1-2.36-2.7l133-132.86,0,0H340.7L225.27,132h0v39.69H330.88a21.17,21.17,0,0,0,12.41-4l23.11-16.74c2.42-1.81,5.82-1,5.82,1.87v55.13h43V15.59h-43Z"
              transform="translate(0 0)"
              style={{
                fill: this.props.colorBorder,
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10"
              }}
            />
          )}
          {version === 5 && (
            <path
              d="M415.16,140.62h0a47,47,0,0,0-5.69-22.2c-9.82-18.49-31.55-33.18-59-39.91-2-.51-4.12-1-6.22-1.37a143.92,143.92,0,0,0-27.57-2.63h0c-8.68.16-13.31,0.66-20.85,2.63-15.27,4-27.57,15.14-29.65,30.78h0a1.8,1.8,0,0,1-3.58-.24l0-56.93H357.2a21.26,21.26,0,0,0,12.47-4l22.92-16.6c2.42-1.82,5.82-1,5.82,1.87V50.75H408V11.06H218.25V117.95h56.27c9.91-8.31,25.13-13.63,42.2-13.63,17.4,0,32.89,5.52,42.78,14.1,6.8,5.89,10.94,13.23,11.26,21.2h0c0,0.72.06,1.44,0.06,2.18,0,20.05-24.21,36.3-54.07,36.3-17.4,0-32.89-5.52-42.78-14.1-7.08-6.14-11.29-13.84-11.29-22.2h-44.4a47,47,0,0,0,5.69,22.2c13.59,25.59,50,43.91,92.78,43.91,54.38,0,98.47-29.6,98.47-66.11C415.19,141.4,415.17,141,415.16,140.62Z"
              transform="translate(0 0)"
              style={{
                fill: this.props.colorBorder,
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10"
              }}
            />
          )}
          {version === 6 && (
            <path
              d="M415.16,140.37h0a47.21,47.21,0,0,0-5.69-22.2c-15.25-28.84-55.58-43.91-92.78-43.91h0c-8.68.16-13.31,0.66-20.85,2.63-15.27,4-27.57,15.14-29.65,30.78h0a1.8,1.8,0,0,1-3.58-.24V106h0l0-40.18c0-20,24.21-36.3,54.07-36.3h0a74.61,74.61,0,0,1,25,4.19,22.16,22.16,0,0,0,23.18-5.27h0c2.3-2,5.82-1,5.82,1.87l0.05,39.17h0v6.74h44.4V66.42h0c0-.2,0-0.39,0-0.59h0a47.21,47.21,0,0,0-5.69-22.2C394.25,14.79,353.92-.28,316.73-0.28h0c-54.38,0-98.47,29.6-98.47,66.11V142.1h0a47.11,47.11,0,0,0,5.67,21.65c13.59,25.59,50,43.91,92.78,43.91,54.38,0,98.47-29.6,98.47-66.11C415.19,141.15,415.17,140.76,415.16,140.37Zm-98.44,37.48c-29.86,0-54.06-16.52-54.06-36.89s24.2-36.89,54.06-36.89,54.06,16.52,54.06,36.89S346.58,177.85,316.73,177.85Z"
              transform="translate(0 0)"
              style={{
                fill: this.props.colorBorder,
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10"
              }}
            />
          )}
        </g>
        <g style={{ clipPath: `url(#clip-path-${this.state.elementId})` }}>
          <path
            d="M202.35,51c-13.59-25.59-50-43.91-92.78-43.91C55.19,7.1,11.1,36.7,11.1,73.21V148.9c0,36.51,44.09,66.11,98.47,66.11,42.78,0,79.19-18.32,92.78-43.91A47,47,0,0,0,208,148.9V73.21A47,47,0,0,0,202.35,51ZM57,157.8A1.86,1.86,0,0,1,55.6,156L55.5,73.21c0-20,24.21-36.3,54.07-36.3,17.75,0,33.51,5.74,43.37,14.62h0L70.21,134a38.67,38.67,0,0,0-11,22.33h0A1.8,1.8,0,0,1,57,157.8Zm106.68-8.91c0,8.36-4.21,16.06-11.29,22.2-9.89,8.58-25.38,14.1-42.78,14.1-18.45,0-34.73-6.21-44.49-15.68l82-81.8A45.26,45.26,0,0,0,160,61.6h0a1.86,1.86,0,0,1,1.34-1.6,1.8,1.8,0,0,1,2.25,1.74Z"
            transform="translate(0 0)"
            style={{
              fill: "#fff",
              stroke: this.props.colorBorder,
              strokeMiterlimit: "10",
              transition: "all .2s linear"
            }}
          />
          {version === 1 && (
            <path
              d="M352.94,198.91H334c-2.88,0-4-3.33-2.12-5.48l17-23.47a21.2,21.2,0,0,0,4-12.44V14.67H318.25l-74.79,75.1v30.15l0.15,0.15,89.49-89.4A1.8,1.8,0,0,1,335.8,33h0a123,123,0,0,0-25.38,74.82v91.07H231v8.51H416.72v-8.51H352.94Z"
              transform="translate(0 0)"
              style={{
                fill: "#fff",
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10",
                transition: "all .2s linear"
              }}
            />
          )}
          {version === 2 && (
            <path
              d="M411.73,189.17a3.15,3.15,0,0,1-5.48,2.12l-23.47-17a21.21,21.21,0,0,0-12.44-4H349.9a197.72,197.72,0,0,0-49.82,6.38l-46,12a1.8,1.8,0,0,1-1.13-3.4l119.77-49c27.93-11.18,49.61-26.38,49.61-57.92,0-36.51-44.09-66.11-98.47-66.11-42.78,0-79.19,18.32-92.78,43.91a47,47,0,0,0-5.69,22.2h44.4c0-8.36,4.21-16.06,11.29-22.2C291,47.48,306.45,42,323.85,42c29.86,0,54.07,16.25,54.07,36.3,0,14.21-7.09,24-31.09,36-12,6-114.75,55.92-114.75,55.92v0h-0.27v39.69H421.33V170.26h-9.6v18.91Z"
              transform="translate(0 0)"
              style={{
                fill: "#fff",
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10",
                transition: "all .2s linear"
              }}
            />
          )}
          {version === 3 && (
            <path
              d="M426.29,142.29a47,47,0,0,0-5.69-22.2,58.75,58.75,0,0,0-6.89-10.15C397.3,90.34,370.66,82.57,346,89.26l-17.16,4.65a1.8,1.8,0,0,1-1.16-3.39L419.11,52.2V12.53H229.59V52.21h9.58v-19a3.15,3.15,0,0,1,5.48-2.12L263.9,45.07a37.56,37.56,0,0,0,22,7.14h77.27L258.27,96v10h69.55c17.4,0,32.89,5.52,42.78,14.1,6.8,5.89,10.94,13.23,11.26,21.2h0c0,0.72.06,1.44,0.06,2.18,0,20.05-24.21,36.3-54.07,36.3-17.4,0-32.89-5.52-42.78-14.1-7.08-6.14-11.29-13.84-11.29-22.2h-44.4a47,47,0,0,0,5.69,22.2c13.59,25.59,50,43.91,92.78,43.91,54.38,0,98.47-29.6,98.47-66.11,0-.4,0-0.79,0-1.18h0Z"
              transform="translate(0 0)"
              style={{
                fill: "#fff",
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10",
                transition: "all .2s linear"
              }}
            />
          )}
          {version === 4 && (
            <path
              d="M372.23,15.59V132h-74a93.12,93.12,0,0,0-56.59,19.17h0a1.8,1.8,0,0,1-2.36-2.7l133-132.86,0,0H340.7L225.27,132h0v39.69H330.88a21.17,21.17,0,0,0,12.41-4l23.11-16.74c2.42-1.81,5.82-1,5.82,1.87v55.13h43V15.59h-43Z"
              transform="translate(0 0)"
              style={{
                fill: "#fff",
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10",
                transition: "all .2s linear"
              }}
            />
          )}
          {version === 5 && (
            <path
              d="M415.16,140.62h0a47,47,0,0,0-5.69-22.2c-9.82-18.49-31.55-33.18-59-39.91-2-.51-4.12-1-6.22-1.37a143.92,143.92,0,0,0-27.57-2.63h0c-8.68.16-13.31,0.66-20.85,2.63-15.27,4-27.57,15.14-29.65,30.78h0a1.8,1.8,0,0,1-3.58-.24l0-56.93H357.2a21.26,21.26,0,0,0,12.47-4l22.92-16.6c2.42-1.82,5.82-1,5.82,1.87V50.75H408V11.06H218.25V117.95h56.27c9.91-8.31,25.13-13.63,42.2-13.63,17.4,0,32.89,5.52,42.78,14.1,6.8,5.89,10.94,13.23,11.26,21.2h0c0,0.72.06,1.44,0.06,2.18,0,20.05-24.21,36.3-54.07,36.3-17.4,0-32.89-5.52-42.78-14.1-7.08-6.14-11.29-13.84-11.29-22.2h-44.4a47,47,0,0,0,5.69,22.2c13.59,25.59,50,43.91,92.78,43.91,54.38,0,98.47-29.6,98.47-66.11C415.19,141.4,415.17,141,415.16,140.62Z"
              transform="translate(0 0)"
              style={{
                fill: "#fff",
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10",
                transition: "all .2s linear"
              }}
            />
          )}
          {version === 6 && (
            <path
              d="M415.16,140.37h0a47.21,47.21,0,0,0-5.69-22.2c-15.25-28.84-55.58-43.91-92.78-43.91h0c-8.68.16-13.31,0.66-20.85,2.63-15.27,4-27.57,15.14-29.65,30.78h0a1.8,1.8,0,0,1-3.58-.24V106h0l0-40.18c0-20,24.21-36.3,54.07-36.3h0a74.61,74.61,0,0,1,25,4.19,22.16,22.16,0,0,0,23.18-5.27h0c2.3-2,5.82-1,5.82,1.87l0.05,39.17h0v6.74h44.4V66.42h0c0-.2,0-0.39,0-0.59h0a47.21,47.21,0,0,0-5.69-22.2C394.25,14.79,353.92-.28,316.73-0.28h0c-54.38,0-98.47,29.6-98.47,66.11V142.1h0a47.11,47.11,0,0,0,5.67,21.65c13.59,25.59,50,43.91,92.78,43.91,54.38,0,98.47-29.6,98.47-66.11C415.19,141.15,415.17,140.76,415.16,140.37Zm-98.44,37.48c-29.86,0-54.06-16.52-54.06-36.89s24.2-36.89,54.06-36.89,54.06,16.52,54.06,36.89S346.58,177.85,316.73,177.85Z"
              transform="translate(0 0)"
              style={{
                fill: "#fff",
                stroke: this.props.colorBorder,
                strokeMiterlimit: "10",
                transition: "all .2s linear"
              }}
            />
          )}
        </g>
      </svg>
    );
  }
}

SVGnumber.propTypes = {
  animate: PropTypes.bool,
  version: PropTypes.number.isRequired,
  classes: PropTypes.string,
  colorBorder: PropTypes.string
};

SVGnumber.defaultProps = {
  animate: true,
  version: 1,
  classes: "",
  colorBorder: "#eceef2"
};
